import templateAccessSendEMail from './accessSendEmail.template.html';
import templateAccessEdit from './editAccess.template.html';

/* @ngInject */

export default (
  $q,
  $scope,
  $state,
  $rootScope,
  $timeout,
  $mdDialog,
  clipboard,
  webpage,
  uiService,
  emailService,
  authenticationService,
  workflowsService,
  changesService,
  navigationService,
  organizationService,
  OrganizationAccess,
  OpportunityContextualType,
  accountsService,
  partnersService,
  labelsService,
  accessService,
  ACCOUNT,
  PARTNER,
  INSTANCE
) => {
  /*
   * Controller Model
   * --------------------------------------------------------------------------------
   */
  $scope.Model = {
    access: {
      outbound: [],
      inbound: []
    },
    accountsAvailable: [],
    partnersAvailable: [],
    labelsAvailable: [],
    workflowsAvailable: [],
    isClipboardSupported: clipboard.supported,
    isReady: false
  };

  /*
   * Controller Functions
   * --------------------------------------------------------------------------------
   */
  const getAccountAvailable = (id) =>
    _.find($scope.Model.accountsAvailable, (ac) => ac.id === id);
  const getWorkflowAvailable = (w) =>
    _.find($scope.Model.workflowsAvailable, (wf) => wf.id === w?.idWorkflow);
  const sort = () => {
    $scope.Model.access.outbound = _.orderBy(
      _.filter($rootScope.CurrentOrganization.access, (a) => a.isOutbound),
      'name'
    );
    $scope.Model.access.inbound = _.orderBy(
      _.filter($rootScope.CurrentOrganization.access, (a) => !a.isOutbound),
      'name'
    );
  };

  /*
   * Controller Scope Events
   * --------------------------------------------------------------------------------
   */
  $scope.$on('accessAddOutbound', ($event) => {
    $scope.editAccess(
      $event,
      OrganizationAccess.build({
        name: 'New outbound referral',
        isOutbound: true,
        isActive: true
      })
    );
  });
  $scope.$on('accessAddInbound', ($event) => {
    $scope.editAccess(
      $event,
      OrganizationAccess.blank({
        name: 'New inbound referral',
        url: `${INSTANCE.url}/api/v1/access/referral`,
        isOutbound: false,
        isActive: true
      })
    );
  });
  $scope.$on('accessAddWebForm', ($event) => {
    $scope.editAccess(
      $event,
      OrganizationAccess.blank({
        name: 'New web form',
        url: `${INSTANCE.url}/api/v1/access/referral`,
        isLoanq: false,
        isWebForm: true,
        isOutbound: false,
        isActive: true
      })
    );
  });
  $scope.$on('accessAddLoanq', ($event) => {
    $scope.editAccess(
      $event,
      OrganizationAccess.blank({
        name: 'New Loanq',
        url: `${INSTANCE.url}/api/v1/access/referral/loanq`,
        isLoanq: true,
        isWebForm: false,
        isOutbound: false,
        isActive: true
      })
    );
  });

  /*
   * Controller Scope Functions
   * --------------------------------------------------------------------------------
   */
  $scope.getAccount = (id) => getAccountAvailable(id);
  $scope.getWorkflow = (a) => getWorkflowAvailable(a);
  $scope.copyAccess = ($event, a) =>
    a.isWebForm
      ? clipboard.copyText(
          `${a.getExternalFormCode(
            $rootScope.CurrentOrganization.organization.name,
            $rootScope.CurrentOrganization.organization.logo,
            $rootScope.CurrentOrganization?.features?.configClientPortal?.display?.privacy?.url,
            $scope.getAccount(a.idTeamMember)?.user?.eMail ||
              $rootScope.CurrentAccount.user.eMail
          )} \n`
        )
      : a.isLoanq
      ? clipboard.copyText(
          `${a.getExternalFormCode(
            $rootScope.CurrentOrganization.organization.name,
            $rootScope.CurrentOrganization.organization.logo,
            $rootScope.CurrentOrganization?.features?.configClientPortal?.display?.privacy?.url,
            $scope.getAccount(a.idTeamMember)?.user?.eMail ||
              $rootScope.CurrentAccount.user.eMail
          )} \n`
        )
      : clipboard.copyText(`${a.name} \nReferral URL: ${a.url} \nReferral key: ${a.id} \n`);
  $scope.emailAccess = ($event, access) => {
    $event.stopPropagation();

    function emailAccessController() {
      this.access = access;
      this.email = {};
      if (this.access.isLoanq) {
        this.email = {
          recipient: '',
          subject: `WebloanQ code for ${$rootScope.CurrentOrganization.organization.name} Salestrekker organization`,
          content: `Hi, \nhere are the details required to configure WebloanQ to my ${
            $rootScope.CurrentOrganization.organization.name
          } organization. \n\n${this.access.getExternalFormCode(
            $rootScope.CurrentOrganization.organization.name,
            $rootScope.CurrentOrganization.organization.logo,
            $rootScope.CurrentOrganization?.features?.configClientPortal?.display?.privacy?.url,
            $scope.getAccount(this.access.idTeamMember)?.user?.eMail ||
              $rootScope.CurrentAccount.user.eMail
          )} \n`
        };
      } else {
        this.email = this.access.isWebForm
          ? {
              recipient: '',
              subject: `Web Form code for ${$rootScope.CurrentOrganization.organization.name} Salestrekker organization`,
              content: `Hi, \nhere are the details required to configure web form to my ${
                $rootScope.CurrentOrganization.organization.name
              } organization. \n\n${this.access.getExternalFormCode(
                $rootScope.CurrentOrganization.organization.name,
                $rootScope.CurrentOrganization.organization.logo,
                $rootScope.CurrentOrganization?.features?.configClientPortal?.display?.privacy
                  ?.url,
                $scope.getAccount(this.access.idTeamMember)?.user?.eMail ||
                  $rootScope.CurrentAccount.user.eMail
              )} \n`
            }
          : {
              recipient: '',
              subject: `Referral access for ${$rootScope.CurrentOrganization.organization.name} Salestrekker organization`,
              content: `Hi, \nhere are the details required to configure your outbound referrals to my ${$rootScope.CurrentOrganization.organization.name} organization. \nIf you have admin privileges, sign-in to your Salestrekker organization and go to Settings -> Access referrals to do so. \n\nReferral URL: ${access.url} \nReferral key: ${access.id} \n`
            };
      }

      this.confirm = () => {
        if (this.email.subject && this.email.content) {
          $mdDialog.hide(this.email);
        } else {
          uiService.toast({
            text: {
              p1: 'Email subject and content',
              p2: 'are required fields',
              p3: 'and cannot be empty'
            },
            warn: true
          });
        }
      };
      this.cancel = () => $mdDialog.cancel();
    }

    $mdDialog
      .show({
        targetEvent: $event,
        template: templateAccessSendEMail,
        controllerAs: '$ctrl',
        controller: emailAccessController
      })
      .then((result) => {
        emailService
          .sendTo({
            recipient: result.recipient,
            subject: result.subject,
            content: result.content
          })
          .then((data) => {
            uiService.toast({
              text: {
                p1: 'E-mail',
                p2: result.subject,
                p3: data.status ? 'has been sent' : 'could not be sent'
              },
              warn: !data.status
            });
          });
      });
  };
  $scope.editAccess = ($event, access) => {
    function editAccessController() {
      this.colors = [
        { n: 'Black', v: '#000000' },
        { n: 'Gray 50', v: '#F9FAFB' },
        { n: 'Gray 100', v: '#F3F4F6' },
        { n: 'Gray 200', v: '#E5E7EB' },
        { n: 'Gray 300', v: '#D1D5DB' },
        { n: 'Gray 400', v: '#9CA3AF' },
        { n: 'Gray 500', v: '#6B7280' },
        { n: 'Gray 600', v: '#4B5563' },
        { n: 'Gray 700', v: '#374151' },
        { n: 'Gray 800', v: '#1F2937' },
        { n: 'Gray 900', v: '#111827' },
        { n: 'Red 50', v: '#FEF2F2' },
        { n: 'Red 100', v: '#FEE2E2' },
        { n: 'Red 200', v: '#FECACA' },
        { n: 'Red 300', v: '#FCA5A5' },
        { n: 'Red 400', v: '#F87171' },
        { n: 'Red 500', v: '#EF4444' },
        { n: 'Red 600', v: '#DC2626' },
        { n: 'Red 700', v: '#B91C1C' },
        { n: 'Red 800', v: '#991B1B' },
        { n: 'Red 900', v: '#7F1D1D' },
        { n: 'Yellow 50', v: '#FFFBEB' },
        { n: 'Yellow 100', v: '#FEF3C7' },
        { n: 'Yellow 200', v: '#FDE68A' },
        { n: 'Yellow 300', v: '#FCD34D' },
        { n: 'Yellow 400', v: '#FBBF24' },
        { n: 'Yellow 500', v: '#F59E0B' },
        { n: 'Yellow 600', v: '#D97706' },
        { n: 'Yellow 700', v: '#B45309' },
        { n: 'Yellow 800', v: '#92400E' },
        { n: 'Yellow 900', v: '#78350F' },
        { n: 'Green 50', v: '#ECFDF5' },
        { n: 'Green 100', v: '#D1FAE5' },
        { n: 'Green 200', v: '#A7F3D0' },
        { n: 'Green 300', v: '#6EE7B7' },
        { n: 'Green 400', v: '#34D399' },
        { n: 'Green 500', v: '#10B981' },
        { n: 'Green 600', v: '#059669' },
        { n: 'Green 700', v: '#047857' },
        { n: 'Green 800', v: '#065F46' },
        { n: 'Green 900', v: '#064E3B' },
        { n: 'Blue 50', v: '#EFF6FF' },
        { n: 'Blue 100', v: '#DBEAFE' },
        { n: 'Blue 200', v: '#BFDBFE' },
        { n: 'Blue 300', v: '#93C5FD' },
        { n: 'Blue 400', v: '#60A5FA' },
        { n: 'Blue 500', v: '#3B82F6' },
        { n: 'Blue 600', v: '#2563EB' },
        { n: 'Blue 700', v: '#1D4ED8' },
        { n: 'Blue 800', v: '#1E40AF' },
        { n: 'Blue 900', v: '#1E3A8A' },
        { n: 'Indigo 50', v: '#EEF2FF' },
        { n: 'Indigo 100', v: '#E0E7FF' },
        { n: 'Indigo 200', v: '#C7D2FE' },
        { n: 'Indigo 300', v: '#A5B4FC' },
        { n: 'Indigo 400', v: '#818CF8' },
        { n: 'Indigo 500', v: '#6366F1' },
        { n: 'Indigo 600', v: '#4F46E5' },
        { n: 'Indigo 700', v: '#4338CA' },
        { n: 'Indigo 800', v: '#3730A3' },
        { n: 'Indigo 900', v: '#312E81' },
        { n: 'Purple 50', v: '#F5F3FF' },
        { n: 'Purple 100', v: '#EDE9FE' },
        { n: 'Purple 200', v: '#DDD6FE' },
        { n: 'Purple 300', v: '#C4B5FD' },
        { n: 'Purple 400', v: '#A78BFA' },
        { n: 'Purple 500', v: '#8B5CF6' },
        { n: 'Purple 600', v: '#7C3AED' },
        { n: 'Purple 700', v: '#6D28D9' },
        { n: 'Purple 800', v: '#5B21B6' },
        { n: 'Purple 900', v: '#4C1D95' },
        { n: 'Pink 50', v: '#FDF2F8' },
        { n: 'Pink 100', v: '#FCE7F3' },
        { n: 'Pink 200', v: '#FBCFE8' },
        { n: 'Pink 300', v: '#F9A8D4' },
        { n: 'Pink 400', v: '#F472B6' },
        { n: 'Pink 500', v: '#EC4899' },
        { n: 'Pink 600', v: '#DB2777' },
        { n: 'Pink 700', v: '#BE185D' },
        { n: 'Pink 800', v: '#9D174D' },
        { n: 'Pink 900', v: '#831843' },
        { n: 'White', v: '#FFFFFF' }
      ];

      this.organization = $rootScope.CurrentOrganization.organization.name;
      this.logo = $rootScope.CurrentOrganization.organization.logo;
      this.privacy =
        $rootScope.CurrentOrganization?.features?.configClientPortal?.display?.privacy?.url;
      this.email = $rootScope.CurrentAccount.user.eMail;
      this.accounts = $scope.Model.accountsAvailable;
      this.partners = $scope.Model.partnersAvailable;
      this.labels = $scope.Model.labelsAvailable;
      this.workflows = $scope.Model.workflowsAvailable;
      this.availableDiversifications = OpportunityContextualType.available();
      this.access = access;
      this.code = '';
      this.updateCode = () => {
        this.code = this.access.getExternalFormCode(
          this.organization,
          this.logo,
          this.privacy,
          this.getAccount(this.access.idTeamMember)?.user?.eMail || this.email
        );
      };

      if (this.access.isLoanq === true) {
        if (!this.access.webForm.kind) {
          this.access.webForm.kind = 'app';
        }
        if (!this.access.webForm.type) {
          this.access.webForm.type = 'af';
        }
      }

      if (this.access.isOutbound === false) {
        const wf = _.find(this.workflows, (w) => w.id === this.access.idWorkflow);
        const st = wf ? _.find(wf.stages, (s) => s.id === this.access.idStage) : null;
        const tm = wf ? _.find(wf.idTeamMembers, (t) => t === this.access.idTeamMember) : null;
        if (wf && st) {
          this.access.idWorkflow = wf.id;
          this.access.idStage = st.id;
          this.access.idTeamMember = tm;
        } else {
          const wff = wf || _.first(this.workflows);
          this.access.idWorkflow = wff.id;
          this.access.idStage = _.first(wff.stages).id;
          this.access.idTeamMember = wff.idOwner;
        }
      }

      this.getAccountsInWorkflow = (acs) => {
        const wf = this.getWorkflow(acs);
        const accIds = [].concat(wf?.idOwner).concat(wf?.idTeamMembers);
        return _.filter(this.accounts, (a) => accIds.indexOf(a.id) > -1);
      };
      this.getAccount = (id) => getAccountAvailable(id);
      this.getWorkflow = (a) => getWorkflowAvailable(a);
      this.setWorkflow = () => {
        this.access.idStage = this.getWorkflow(this.access)?.stages[0]?.id;
        this.access.idTeamMember = this.getWorkflow(this.access)?.idOwner;
        if (!this.access.idWorkflow || this.access.idWorkflow === 'undefined') {
          this.access.idStage = undefined;
          this.access.idTeamMember = undefined;
          this.access.diversification = undefined;
        }
        if (!this.getWorkflow(this.access).isHomeLoan()) {
          this.access.diversification = undefined;
        }
      };
      this.setWebloanQKind = () => {
        if (this.access.webForm.kind !== 'cal') {
          this.access.webForm.type = 'af';
        }
        if (this.access.webForm.kind === 'cal') {
          this.access.webForm.type = 'bp';
        }
      };
      this.setStage = () => {};
      this.setTeamMember = () => {};
      this.confirm = () => $mdDialog.hide(this.access);
      this.cancel = () => $mdDialog.cancel();

      this.copyToClipboard = () => {
        $scope.copyAccess(null, this.access);
        this.confirm();
      };
    }

    $mdDialog
      .show({
        targetEvent: $event,
        template: templateAccessEdit,
        controllerAs: '$ctrl',
        controller: editAccessController
      })
      .then((a) => {
        accessService.updateAccess(a);
        $scope.saveChanges();
      });
  };
  $scope.deleteAccess = ($event, a) => {
    $event.stopPropagation();
    const deleteTimeout = $timeout(() => {
      accessService.deleteAccess(a);
      $scope.saveChanges();
      uiService.toast({
        text: {
          p1: 'Access',
          p2: a.name,
          p3: 'has been deleted'
        }
      });
    }, 5250);
    uiService
      .toast({
        text: {
          p1: 'Access',
          p2: a.name,
          p3: 'will be deleted'
        },
        warn: true,
        action: 'UNDO'
      })
      .then((action) => {
        if (action) {
          $timeout.cancel(deleteTimeout);
          uiService.toast({
            text: {
              p1: 'Access',
              p2: a.name,
              p3: 'deletion has been undone'
            }
          });
        }
      });
  };
  $scope.saveChanges = () => {
    const organizationData = {
      id: $rootScope.CurrentOrganization.id,
      access: $rootScope.CurrentOrganization.access
    };
    return organizationService.updateOrganization(organizationData).then((result) => {
      if (result.status) {
        navigationService
          .organizationChange({
            idOrganization: $rootScope.CurrentOrganization.id
          })
          .then(() => {
            $state.reload();
          });
      } else {
        uiService.toast({
          text: {
            p1: 'Failed to',
            p2: 'save',
            p3: 'your changes'
          },
          warn: true
        });
      }
      return { status: !!result.status };
    });
  };

  /*
   * Controller Initialization
   * --------------------------------------------------------------------------------
   */
  const init = () => {
    if ($rootScope.CurrentAccount.isAdministrator) {
      $q.all([
        organizationService.readOrganization({ id: $rootScope.CurrentOrganization.id }),
        workflowsService.getAvailable({ isActive: true }),
        accountsService.getAvailable({ isActive: true, fields: ACCOUNT.FIELDS.CHIPS }),
        partnersService.getAvailable({ isActive: true, fields: PARTNER.FIELDS.LIST }),
        labelsService.getAvailable({
          type: 'ticket',
          orderBy: 'name',
          coerceTo: 'string',
          isDescending: false,
          isActive: true
        })
      ])
        .then((data) => {
          /* eslint-disable no-param-reassign */
          /* eslint-disable prefer-destructuring */
          // Overwrite $rootScope values in case they've reverted to values within Token
          $rootScope.CurrentOrganization.access = _.map(data[0].access, (a) =>
            OrganizationAccess.build(a)
          );
          $scope.Model.workflowsAvailable = data[1];
          $scope.Model.accountsAvailable = data[2];
          $scope.Model.partnersAvailable = data[3];
          $scope.Model.labelsAvailable = data[4];
          sort();
          /* eslint-enable prefer-destructuring */
          /* eslint-enable no-param-reassign */
        })
        .then(() => {
          // Declare Model as Ready and start rendering the page
          webpage.pageTitle('Integrations : Access');
          $scope.Model.isReady = true;
        });
    }
  };

  webpage.pageTitle('Loading, please wait');
  init();
};
